import service from "./service"

export default async (data) => {

    const {
        backgroundRequestId,
        comments,
        flag,
    } = data

    return service({
        backgroundRequestId,
        comments,
        reviewRequiredFlag: flag ? "review" : undefined,
    })
}
